import React, { useState } from 'react';
import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';
import { Chip, TableCell, TableRow, Tooltip } from '@material-ui/core';
import ModalBarcode from '../common/ModalBarcode';
import StatusLoan from './StatusLoan';
import { NewLoanUseStyles } from './styles.style';
import { fullTime, mediumDate, mediumTime } from '../../helpers/datetime';
import { Loan } from '../../redux/loans/models/Loan';

const LoanRow = ({ loan }: { loan: Loan }) => {
  const classes = NewLoanUseStyles();
  const {
    id,
    users_str,
    users_id,
    created,
    date_repayment,
    loan_status_str,
    days_past_due,
    detail,
    complete_return_date,
  } = loan || {};
  const isExceededLoan = Number(days_past_due) < 0;
  const [showBarcode, setShowBarcode] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const now = new Date();
  const expirationNow =
    now.getDate() === date_repayment.getDate() &&
    now.getMonth() === date_repayment.getMonth() &&
    now.getFullYear() === date_repayment.getFullYear() &&
    !complete_return_date;
  return (
    <TableRow key={id} className={classes.tableRow}>
      <TableCell component='th' scope='row'>
        {id}
      </TableCell>
      <TableCell>{`${users_str} (${users_id})`}</TableCell>
      <TableCell>
        <div className={classes.datetime}>
          <b>Registro:</b>{' '}
          <Tooltip title={fullTime(created)} aria-label={fullTime(created)}>
            <div>
              {mediumDate(created, '-')} {mediumTime(created, '-')}
            </div>
          </Tooltip>
        </div>
        <div className={classes.datetime}>
          <b>Fecha de entrega:</b>{' '}
          <Tooltip
            title={fullTime(date_repayment)}
            aria-label={fullTime(date_repayment)}
          >
            <div>
              {mediumDate(date_repayment, '-')}{' '}
              {mediumTime(date_repayment, '-')}
            </div>
          </Tooltip>
        </div>
      </TableCell>
      <TableCell>
        <div className={`${classes.status}`}>
          {loan_status_str}
          {isExceededLoan && (
            <Chip
              style={{ background: '#b92929', color: 'white' }}
              icon={<AccessAlarmsIcon style={{ color: 'white' }} />}
              label={`Excede los días de prestamo`}
              clickable={false}
            />
          )}
          {expirationNow && (
            <Chip
              style={{ background: '#ffd001', color: 'white' }}
              icon={<AccessAlarmsIcon style={{ color: 'white' }} />}
              label={`Expira hoy`}
              clickable={false}
            />
          )}
        </div>
      </TableCell>
      <TableCell>
        <StatusLoan
          showStatus={showStatus}
          setShowStatus={setShowStatus}
          list={detail}
        />
      </TableCell>

      {showBarcode && (
        <ModalBarcode
          barcode={'continuar'}
          onClose={() => setShowBarcode(false)}
        />
      )}
    </TableRow>
  );
};

export default LoanRow;
